import { ISbStoryData } from '@storyblok/js';
import { defaultLanguage, defaultLocations, Language, languages, locations } from '../../consts';
import { LinkDefinition } from '../../interfaces/link';
import { buildLocale } from '../../lib/build-locale';
import { localeToPathPrefix } from '../../pipes/translate-link.pipe';

export const getStoryblokTranslatedPathLinks = (
  story: ISbStoryData,
  correctPicflowUrl: string,
  currentPath: string[]
) => {
  const links: (LinkDefinition & { locale: string })[] = [];

  if (story.default_full_slug?.endsWith('-template')) {
    const langs =
      currentPath[0] === 'compare'
        ? languages.filter(l => l.programaticPages.compare).map(l => l.lang)
        : currentPath[0] === 'convert'
          ? languages.filter(l => l.programaticPages.convert).map(l => l.lang)
          : languages.map(lang => lang.lang);
    langs.forEach(lang => {
      if (!languages.filter(l => l.i18n.website).some(l => l.lang === lang)) return;
      const availableLocations = locations[lang];
      availableLocations.forEach(location => {
        const isDefault = lang === defaultLanguage && location === defaultLocations[lang];
        const locale = buildLocale(lang, location);
        const hreflang = locale;
        const localePrefix = localeToPathPrefix(locale);

        links.push({
          rel: 'alternate',
          hreflang,
          href: `${correctPicflowUrl}/${localePrefix ? `${localePrefix}/` : ''}${currentPath.join('/')}`,
          locale: locale,
        });
        if (isDefault) {
          links.push({
            rel: 'alternate',
            hreflang: 'x-default',
            href: `${correctPicflowUrl}/${currentPath.join('/')}`,
            locale: locale,
          });
        }
      });
    });

    return links;
  }

  // handle normal stories
  const path = ('/' + (story.default_full_slug ?? '')).replace(/\/home$/, '/').replace(/(.+)\/$/, '$1');

  locations[defaultLanguage].forEach(location => {
    const isDefault = location === defaultLocations[defaultLanguage];
    const locale = buildLocale(defaultLanguage, location);
    const localePrefix = localeToPathPrefix(locale);
    const fixedPath = path.replace(/\/home$/, '/').replace(/(.+)\/$/, '$1');

    links.push({
      rel: 'alternate',
      hreflang: locale,
      href: `${correctPicflowUrl}${localePrefix ? `/${localePrefix}` : ''}${fixedPath}`,
      locale: locale,
    });
    if (isDefault) {
      links.push({
        rel: 'alternate',
        hreflang: 'x-default',
        href: `${correctPicflowUrl}${fixedPath}`,
        locale: locale,
      });
    }
  });

  story.translated_slugs.forEach(item => {
    if (!item['published']) return;
    const lang = item.lang as Language;
    if (!languages.some(l => l.lang === lang && l.i18n.website)) return;

    const availableLocations = locations[lang];

    availableLocations.forEach(location => {
      const locale = buildLocale(lang, location);
      const localePrefix = localeToPathPrefix(locale);
      const fixedPath = `${localePrefix ? `/${localePrefix}` : ''}/${item.path}`
        .replace(/\/home$/, '/')
        .replace(/(.+)\/$/, '$1');

      links.push({
        rel: 'alternate',
        hreflang: locale,
        href: `${correctPicflowUrl}${fixedPath}`,
        locale: locale,
      });
    });
  });

  return links;
};
